import { convertRainbowPercentileComparisonData } from "./MeasurementSystem";

const convertValues = (values, measurementUnit) => {
	if (!values || values.every(value => value === null || value === undefined)) return [];
	return values.map((t) => (t != null ? measurementUnit.formatFine(t) : null));
};

const getSessionDates = sessions => {
    return sessions.map(t => t.date);
};

const getSessionTitles = sessions => {
    return sessions.map(t => t.title);
};

const convertRainbowChart = (kpi, sessions, measurementUnit) => {
    return {
        sessionValues: convertValues(kpi.sessionValues, measurementUnit),
        sessionValuesAsSub: convertValues(kpi?.sessionValuesAsSub, measurementUnit),
        rollingAverage: convertValues(kpi.rollingAverage, measurementUnit),
        comparisonData: convertRainbowPercentileComparisonData(
            kpi.epochValues,
            measurementUnit
        ),
        sessionDateStrings: getSessionDates(sessions),
        sessionTitles: getSessionTitles(sessions),
        type: "rainbow",
        yAxisLabel: `Peak (${measurementUnit.unitShort}/min)`
    };
};

const convertChart = (kpi, sessions, measurementUnit) => {
    return {
        sessionValues: convertValues(kpi.sessionValues, measurementUnit),
        sessionValuesAsSub: convertValues(kpi?.sessionValuesAsSub, measurementUnit),
        rollingAverage: convertValues(kpi.rollingAverage, measurementUnit),
        sessionDateStrings: getSessionDates(sessions),
        sessionTitles: getSessionTitles(sessions),
        comparisonData: {
            upperBound: convertValues(kpi.upperBound, measurementUnit),
            lowerBound: convertValues(kpi.lowerBound, measurementUnit),
            average: convertValues(kpi.average, measurementUnit),
            target: kpi.target ? convertValues(kpi.target, measurementUnit) : null
        },
        yAxisLabel: measurementUnit.unitLong
    };
};

const retrievePlayerSessionData = (sessions, kpiData) => {
	const sessionValues = [];
	const sessionValuesAsSub = [];
	const rollingAverages = [];

	sessions.forEach((session) => {
		const rawSessionData = kpiData?.[session.sessionId];
		const playedFullMatch = session.playedFullMatch;

		if (rawSessionData != null) {
			const sessionValue = typeof rawSessionData === "object" ? rawSessionData.sessionValue : rawSessionData;
			const rawRollingAverage = typeof rawSessionData === "object" ? rawSessionData.rollingAverage ?? null : null;

			if (typeof playedFullMatch === "boolean") {
				if (playedFullMatch) {
					sessionValues.push(sessionValue);
					sessionValuesAsSub.push(null);
					rollingAverages.push(rawRollingAverage);
				} else {
					sessionValues.push(null);
					sessionValuesAsSub.push(sessionValue);
					rollingAverages.push(null);
				}
			} else {
				sessionValues.push(sessionValue);
				sessionValuesAsSub.push(null);
				rollingAverages.push(rawRollingAverage);
			}
		} else {
			sessionValues.push(null);
			sessionValuesAsSub.push(null);
			rollingAverages.push(null);
		}
	});

	return { sessionValues, sessionValuesAsSub, rollingAverages };
};



const generateKpiEpochData = (sessions, kpiData, comparisonData) => {
    const { sessionValues, sessionValuesAsSub, rollingAverages } = retrievePlayerSessionData(sessions, kpiData);
    if (sessionValues.length > 0 && sessionValues.some(t => t !== null)) {
        return {
            sessionValues: sessionValues,
            sessionValuesAsSub: sessionValuesAsSub,
            rollingAverage: rollingAverages,
            epochValues: comparisonData ? comparisonData : []
        };
    }
};

const mapKpiCategory = (sessions, kpiData, comparisonData) => {
    const { sessionValues, rollingAverages, sessionValuesAsSub } = retrievePlayerSessionData(sessions, kpiData);
    if (sessionValues.length > 0 && sessionValues.some(t => t !== null)) {
        return {
            sessionValues: sessionValues,
            sessionValuesAsSub: sessionValuesAsSub,
            rollingAverage: rollingAverages,
            average: comparisonData ? [comparisonData.average] : [],
            lowerBound: comparisonData ? [comparisonData.average - comparisonData.standardDeviation] : [],
            upperBound: comparisonData ? [comparisonData.average + comparisonData.standardDeviation] : [],
            target: comparisonData ? (comparisonData.target ? [comparisonData.target] : null) : null
        };
    }
};

export { convertChart, convertRainbowChart, mapKpiCategory, generateKpiEpochData };